import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const LogoOrbIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 46 46"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<circle opacity="0.2" cx="23" cy="23" r="23" fill="url(#paint0_linear_5446_24848)" />
			<circle
				opacity="0.2"
				cx="23.0007"
				cy="22.9998"
				r="16.2146"
				fill="url(#paint1_linear_5446_24848)"
			/>
			<g filter="url(#filter0_d_5446_24848)">
				<circle cx="23.0009" cy="23.0001" r="9.60536" fill="url(#paint2_linear_5446_24848)" />
			</g>
			<defs>
				<filter
					id="filter0_d_5446_24848"
					x="12.2974"
					y="13.3948"
					width="21.4072"
					height="21.407"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="1.09814" />
					<feGaussianBlur stdDeviation="0.549072" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5446_24848" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_5446_24848"
						result="shape"
					/>
				</filter>
				<linearGradient
					id="paint0_linear_5446_24848"
					x1="-20.5853"
					y1="23.236"
					x2="23.236"
					y2="67.0573"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#B491FF" />
					<stop offset="1" stopColor="#3300FF" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_5446_24848"
					x1="-7.72612"
					y1="23.1662"
					x2="23.167"
					y2="54.0594"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#B491FF" />
					<stop offset="1" stopColor="#3300FF" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_5446_24848"
					x1="4.79857"
					y1="23.0987"
					x2="23.0994"
					y2="41.3995"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#B491FF" />
					<stop offset="1" stopColor="#3300FF" />
				</linearGradient>
			</defs>
		</svg>
	)
}

export default LogoOrbIcon
